import { render, staticRenderFns } from "./candidate-list-screen.html?vue&type=template&id=68f89c56&scoped=true&external"
import script from "./candidate-list-screen.js?vue&type=script&lang=js&external"
export * from "./candidate-list-screen.js?vue&type=script&lang=js&external"
import style0 from "./candidate-list-screen.scss?vue&type=style&index=0&id=68f89c56&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f89c56",
  null
  
)

export default component.exports